import CryptoJS from "crypto-js";


export default function encryptPassword(password, key) {
    let keyHash = CryptoJS.SHA256(key);
    let keyBytes = CryptoJS.enc.Hex.parse(keyHash.toString());
    let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(password), keyBytes, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString(); 
}

export const formatAmount = (num) => {
    if (num === null || num === undefined) return '0';
    const abs = Math.abs(num);
    if (abs >= 1e9) return (num / 1e9).toFixed(2) + 'B';
    if (abs >= 1e6) return (num / 1e6).toFixed(2) + 'M';
    if (abs >= 1e3) return (num / 1e3).toFixed(2) + 'K';
    return num.toFixed(2);
  };
  